import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { css, keyframes } from "@emotion/core";
import { colors } from "styling/variables";
import Loader from "./Loader";

// can't import and use libs in this component
// this component is mounted before vendors js is loaded

const Message = styled("div")`
  text-align: center;
  color: ${colors.white};
  margin: 20px 0;
`;

const smallSpinner = css`
  border-width: 3px;
  height: 26px;
  width: 26px;
  animation-duration: 0.7s;
`;

const mediumSpinner = css`
  border-width: 5px;
  height: 50px;
  width: 50px;
  animation-duration: 0.8s;
`;

const largeSpinner = css`
  border-width: 7px;
  height: 75px;
  width: 75px;
  animation-duration: 0.9s;
`;

const grayLightSpinner = css`
  border-color: ${colors.silverChalice};
  border-bottom-color: ${colors.scorpion};
`;

const grayDarkSpinner = css`
  border-color: ${colors.doveGray};
  border-bottom-color: ${colors.silver};
`;

const whiteSoftSpinner = css`
  border-color: ${colors.mercuryDark};
  border-bottom-color: ${colors.dustyGray};
`;

const spin = keyframes`
  0% { transform: rotate(0); }
  50% { transform: rotate(180deg); }
  100% { transform: rotate(360deg); }
`;

const spinning = css`
  animation: ${spin} 0.9s 0s linear infinite;
`;

const Spinner = styled("div")`
  border-radius: 100%;
  border-style: solid;
  background: 0 0 !important;
  display: block;
  margin: 0 auto;
  ${props => {
    if (props.stopSpin === false) return spinning;
  }};
  ${props => {
    if (props.size === "small") return smallSpinner;
    if (props.size === "medium") return mediumSpinner;
    if (props.size === "large") return largeSpinner;
  }};
  ${props => {
    if (props.color === "gray-light") return grayLightSpinner;
    if (props.color === "gray-dark") return grayDarkSpinner;
    if (props.color === "white-soft") return whiteSoftSpinner;
  }};
  ${props => {
    if (props.styles && props.styles.spinner)
      return props.styles.spinner(props.stopSpin);
  }};
`;

class LoaderSpinner extends PureComponent {
  render() {
    return (
      <Loader {...this.props}>
        <div>
          <Spinner
            stopSpin={this.props.stopSpin}
            size={this.props.size}
            color={this.props.color}
            styles={this.props.styles}
          />
          {this.props.message ? <Message>{this.props.message}</Message> : null}
        </div>
      </Loader>
    );
  }
}

LoaderSpinner.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
  message: PropTypes.string,
  stopSpin: PropTypes.bool,
  styles: PropTypes.object
};

LoaderSpinner.defaultProps = {
  size: "large",
  color: "white-soft",
  stopSpin: false
};

export default LoaderSpinner;
